"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Senders_1 = require("./Senders");
var EngineResponseToReducedData_1 = require("./EngineResponseToReducedData");
function SendRequest(_a) {
    var inputValidator = _a.inputValidator, standardInputValues = _a.standardInputValues, slideOutValues = _a.slideOutValues, customAssetAllocationValues = _a.customAssetAllocationValues, smartShieldChoiceValue = _a.smartShieldChoiceValue, smartShieldChoice = _a.smartShieldChoice, onRequest = _a.onRequest, setRetirementLoader = _a.setRetirementLoader, setBacktestLoader = _a.setBacktestLoader, onProjectionResponse = _a.onProjectionResponse, onBacktestResponse = _a.onBacktestResponse, config = _a.config, userData = _a.userData;
    return function () {
        if (!!inputValidator) {
            var isValid = inputValidator(standardInputValues, slideOutValues, customAssetAllocationValues, smartShieldChoiceValue);
            if (!isValid) {
                return;
            }
        }
        var requestData = { standardInputValues: standardInputValues, slideOutValues: slideOutValues, smartShieldChoiceValue: smartShieldChoiceValue, smartShieldChoice: smartShieldChoice, customAssetAllocationValues: customAssetAllocationValues, userData: userData, destination: config.proxyurl };
        onRequest(requestData);
        var $ = require("jquery");
        setRetirementLoader(true);
        setBacktestLoader(true);
        var timeOutDelay = config.isDebugging ? config.timeoutDelay : 100000; //100 seconds
        var retirementTimeoutPromise = createTimeoutPromise(timeOutDelay);
        var retirementOutcomesPromise = Senders_1.projectionSend(requestData, requestData.destination, EngineResponseToReducedData_1.reduceRetirementData);
        var retirementOutcomesFulfill = Promise.race([retirementOutcomesPromise, retirementTimeoutPromise])
            .then(function (result) {
            setRetirementLoader(false);
            onProjectionResponse(result);
        }).catch(function (err) {
            alert(err);
            setRetirementLoader(false);
        });
        var backtestTimeoutPromise = createTimeoutPromise(timeOutDelay);
        var backtestPromise = Senders_1.backtestSend(requestData, requestData.destination, EngineResponseToReducedData_1.reduceBacktestData, config.isDebugging);
        var backtestFullfil = Promise.race([backtestPromise, backtestTimeoutPromise])
            .then(function (result) {
            setBacktestLoader(false);
            onBacktestResponse(result);
        }).catch(function (err) {
            alert(err);
            setBacktestLoader(false);
        });
    };
}
exports.default = SendRequest;
function createTimeoutPromise(delay) {
    return new Promise(function (resolve, reject) {
        setTimeout(reject, delay, "Failed to get response within " + delay / 1000 + " second(s)");
    });
}
//# sourceMappingURL=SendRequest.js.map